//--- Custom small scripts
function mainFunction () {
    //- Variable block -//
  
    // body document element
    const bodyDoc = document.getElementsByTagName('BODY')[0];
    // returns the location path for the site splited in an array
    const docLocationPath = window.location.pathname;
  
    // the wrapper for main navigation menu
    const navMenuWrapp = document.getElementById('navigation-collapse-main');
    // main navigation menu
    const navMenu = document.getElementById('top_menu');
    // main navigation trigger for small widts (the burger icon)
    const navTrigger = document.getElementById('main-nav-toggle');
  
    // vetrical navigation main wrapper
    const vmWrapper = document.getElementById('vertical-menu-doc');
    // vetrical navigation show/hide button trigger
    const vmTrigger = document.getElementById('showmenu');
    // vertical navigation menu container
    const vmContainer = document.getElementById('side-navigation');
    // all sublevels in vertical menu
    const vmSubMenuTrigger = document.querySelectorAll('.vertical-menu-doc .has-children > a');
  
    // page content container
    const mainContainer = document.getElementById('content-holder');

    // view change toggle wrapper
    const viewChange = document.getElementById('view-change');
    const tasksView = document.getElementById('tasks-view');
    const tasksViewTitle = document.getElementById('tasks-view-title');
    const assigmentsView = document.getElementById('assigments-view');
    const assigmentsViewTitle = document.getElementById('assigments-view-title');


    let cardListings = document.querySelectorAll('.vre-card');
    const drawerDialog = document.getElementById('drawerDialog');
    const listingImage = document.getElementById('listingImage');
    const drawerListingAssignee = document.getElementById('drawerListingAssignee');
    const drawerListingTitle = document.getElementById('drawerListingTitle');
    const cardRemove = document.getElementById('cardRemove');
    const closeDrawer = document.getElementById('closeDrawer');
    const overlayFirstStepp = document.getElementById('firstStepp');
    const overlaySecondStepp = document.getElementById('secondStepp');

    // Demo for selected/active state for segment control
    const segmentedModule = document.querySelectorAll('.btn-group-tabs');




    if(segmentedModule.length > 0) {
        segmentedModule.forEach((el:any) => {
            let children = el.querySelectorAll('.btn');
            let animation = false;
            let btnWidth = 0
            let btnOffset = 0;
            let elOffset:any = 0;

            if(el.classList.contains('btn-group-animation')) {
                animation = true;

                for (let btn of children) {
                    if(btn.classList.contains('active')) {
                        btnWidth = btn.clientWidth;
                        elOffset = el.offsetLeft + 3;
                        btnOffset = btn.offsetLeft - elOffset;
                        el.style.setProperty('--btn-grp-animation-width', btnWidth + 'px');
                        el.style.setProperty('--btn-grp-animation-offset', btnOffset + 'px');
                        break;
                    }
                }
            }

            el.addEventListener('click', (e) => {
                let tr = e.target.closest('.btn');

                if(tr) {
                    children.forEach(elm => {
                        elm.classList.remove('active');
                        elm.ariaSelected = false;
                    });

                    tr.classList.add('active');
                    tr.ariaSelected = true;
                    tr.blur();

                    if(animation) {
                        let trWidth = tr.clientWidth;
                        elOffset = el.offsetLeft + 4;
                        let trOffset = tr.offsetLeft - elOffset;
                        el.style.setProperty('--btn-grp-animation-width', trWidth + 'px');
                        el.style.setProperty('--btn-grp-animation-offset', trOffset + 'px');
                    }
                }
            });
        });
    }

    if(cardListings.length > 0) {
      cardListings.forEach((card:any) => {
        card.addEventListener('click', (e) => {
          let cardTitle = card.querySelector('.vre-card-details').cloneNode(true);
          let cardAssignee = card.querySelector('.vre-card-assignee').cloneNode(true);
          let imgScr = card.getAttribute('data-img');

          // console.log('imgScr', imgScr);
          listingImage.setAttribute('src', imgScr);

          //remove the node content
          while (drawerListingTitle.firstChild) {
            drawerListingTitle.removeChild(drawerListingTitle.firstChild);
          }
          while (drawerListingAssignee.firstChild) {
            drawerListingAssignee.removeChild(drawerListingAssignee.firstChild);
          }

          drawerListingTitle.appendChild(cardTitle);
          drawerListingAssignee.appendChild(cardAssignee);

          drawerDialog.classList.add('show');

          cardRemove.onclick = () => {
            overlayFirstStepp.classList.remove('hidden');

            setTimeout(() => {
              card.classList.add('hide');
              setTimeout(() => {
                card.remove();
              }, 400);
              overlayFirstStepp.classList.add('hidden');
              overlaySecondStepp.classList.remove('hidden');
            }, 1200);

            closeDrawer.onclick = () => {
              drawerDialog.classList.remove('show')
              setTimeout(() => {
                overlaySecondStepp.classList.add('hidden');
              }, 500);
            };
          }
        });
      });
    }









  // on click in the document
  function OnDocumentClick (event) {
    var _vw = window.innerWidth;
    var _this = event.target;

    if(_this.closest('.dropdown-toggle')) {
      var _tr = _this.closest('.dropdown-toggle');
      var _ele = _tr.parentNode.classList.contains('open');

      remOpenDropdown();

      if(!_ele) {
        _tr.parentNode.classList.add('open');
        _tr.ariaExpanded = true;
        _tr.nextElementSibling.ariaExpanded = true;
        _tr.nextElementSibling.ariaHidden = false;
      }
    }

    if(!_this.closest('.dropdown-toggle')) {
      remOpenDropdown();
    }

    if(_this.closest('.btn-close')) {
        _this.closest('.cookies-alert').style.display='none';
    }

    if(_this.closest('#view-change')) {
        let trView = _this.closest('.btn');
        if(trView) {
            let trViewData = trView.getAttribute('data-target')
            if(trViewData == "tasks-view") {
                tasksView.classList.remove('hidden');
                tasksViewTitle.classList.remove('hidden');
                assigmentsView.classList.add('hidden');
                assigmentsViewTitle.classList.add('hidden');
            }
            else if(trViewData == "assigments-view") {
                tasksView.classList.add('hidden');
                tasksViewTitle.classList.add('hidden');
                assigmentsView.classList.remove('hidden');
                assigmentsViewTitle.classList.remove('hidden');
            }
        }
    }

    if(_this.closest('.btn').hasAttribute('data-mod')) {
      let trMod = document.getElementById(_this.closest('.btn').getAttribute('data-target'));
      if (trMod) {
        trMod.classList.remove('in');
      }
    }

    // if(!_this.classList.contains('navigation-toggle')) {
    //   if(_vw < 992) {
    //     navTrigger.ariaExpanded = false;
    //     navMenuWrapp.classList.remove('open');
    //     navMenuWrapp.ariaExpanded = false;
    //     navMenuWrapp.ariaHidden = true;
    //   }
    // }
  }


  // close all dropdown's
  function remOpenDropdown() {
    document.querySelectorAll('.dropdown, .btn-split').forEach(function(e){
      if (e.classList.contains('open')) {
        var _dropTriggeer: any = e.querySelector('.dropdown-toggle');
        var _dropMenu: any = e.querySelector('.dropdown-menu');
        e.classList.remove('open');
        _dropTriggeer.ariaExpanded = false;
        _dropMenu.ariaExpanded = false;
        _dropMenu.ariaHidden = true;
      }
    }, false);
  }

  // 
  document.onclick = function(){OnDocumentClick(event);};
};
// load/call 'mainFunction' after document is loaded
document.addEventListener('DOMContentLoaded', mainFunction);